import { Action } from '@ngrx/store';

export const REQUEST_LOCATION = '[Request][Location]';
export const RESPONSE_SUCCESS_LOCATION = '[Response][Success][Location]';
export const RESPONSE_FAIL_LOCATION = '[Response][Fail][Location]';

export class RequestLocation implements Action {
  readonly type = REQUEST_LOCATION;
  constructor(public payload: any) {}
}

export class ResponseSuccessLocation implements Action {
  readonly type = RESPONSE_SUCCESS_LOCATION;
  constructor(public payload: any) {}
}
export class ResponseFailLocation implements Action {
  readonly type = RESPONSE_FAIL_LOCATION;
  constructor(public payload: any) {}
}
